import { lazy, Suspense } from 'react';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { useSelector } from 'react-redux';
import { localeSelector } from 'reducers/userAuthSlice';
import { useLocation } from 'react-router-dom';
import 'dayjs/locale/it';
import { lightThemeConfig } from 'constants/styles/lightTheme';
import { darkThemeConfig } from 'constants/styles/darkTheme';

const CssBaseline = lazy(() => import('@mui/material/CssBaseline'));

const AppThemeProvider = ({ children, themeValue }) => {
	const locale = useSelector(localeSelector);
	const location = useLocation();

	const getMUILocaleFromAppLocale = appLocale => {
		switch (appLocale) {
			case 'it': {
				const { itIT } = import('@mui/material/locale');
				return itIT;
			}
			default: {
				const { enUS } = import('@mui/material/locale');
				return enUS;
			}
		}
	};

	const lightTheme = createTheme(lightThemeConfig, getMUILocaleFromAppLocale(locale));
	const darkTheme = createTheme(darkThemeConfig, getMUILocaleFromAppLocale(locale));

	// Determine theme based on route or explicit themeValue prop
	const shouldUseDarkTheme =
		themeValue === 'dark' ||
		location.pathname === '/login' ||
		location.pathname === '/signup' ||
		location.pathname === '/confirm-signup' ||
		location.pathname === '/reset-password' ||
		location.pathname.startsWith('/redeem/');

	const theme = shouldUseDarkTheme ? darkTheme : lightTheme;

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
			<StyledEngineProvider injectFirst>
				<ThemeProvider theme={theme}>
					<Suspense fallback={null}>
						<CssBaseline />
					</Suspense>
					{children}
				</ThemeProvider>
			</StyledEngineProvider>
		</LocalizationProvider>
	);
};
export default AppThemeProvider;
